import { installGlobals, PluginStatic } from "@pexip-engage-public/plugin-instance";
import { logger } from "@pexip-engage-public/plugin-utils";

export function initialize(scriptEl: HTMLScriptElement) {
  const hasSetV1Script = checkForV1Fallback();
  if (hasSetV1Script) return;

  const enterpriseUrl = getEnterpriseUrl(scriptEl);
  if (!enterpriseUrl) return;

  installGlobals();

  if (PluginStatic.url === undefined) {
    PluginStatic.setEnterpriseUrl(enterpriseUrl);
  } else if (PluginStatic.url !== enterpriseUrl) {
    logger.warn("Plugin is being loaded from 2 sources, backing out...");

    return;
  }

  [
    { label: "legacy containers", elements: document.querySelectorAll(".skedify-plugin") },
    { label: "containers", elements: document.querySelectorAll(".pexip-engage-plugin") },
  ].forEach(({ elements, label }) => {
    if (elements.length === 0) return;

    logger.debug(`Found ${elements.length} plugin ${label}, initializing...`);

    elements.forEach((target) => {
      if (target.getAttribute("data-pexip-auto-init") === "false") {
        logger.debug('Encountered `data-pexip-auto-init="false"`, skipping...');
      }

      new PluginStatic(target, {});
    });
  });
}

function checkForV1Fallback() {
  if (window.location.search.indexOf("pexip-engage-plugin=v1") === -1) return false;

  const oldScriptEl = document.querySelector<HTMLScriptElement>(
    ["script[src*='skedify-plugin.js']", "script[src*='SkedifyPlugin.js']"].join(", "),
  );

  if (!oldScriptEl) return false;

  const scriptEl = document.createElement("script");

  scriptEl.src = oldScriptEl.src
    .replace("skedify-plugin", "skedify-plugin-v1")
    .replace("SkedifyPlugin", "skedify-plugin-v1");

  scriptEl.async = true;
  scriptEl.defer = true;
  scriptEl.type = "application/javascript";
  document.head.appendChild(scriptEl);

  return true;
}

export function getEnterpriseUrl(scriptEl: HTMLScriptElement) {
  try {
    const url = new URL(scriptEl.src);
    let enterprise = url.pathname.split("/")[1];

    if (enterprise?.endsWith(".js")) {
      // User probably misconfigured loading the plugin, attempt to fix it with the ${enterprise} prefix.
      enterprise = url.hostname.split(".")[0];

      logger.warn(`Encountered incorrect plugin URL: ${scriptEl.src}.
Tried to fix it by using the following URL: "${url.origin}/${enterprise}/pexip-engage-plugin.js"
If plugin succeeds to load, please edit your URL to the above URL.`);
    }

    if (!enterprise) {
      logger.warn("Couldn't not determine enterprise, are you using the correct link?");

      return;
    }

    return url.origin + "/" + enterprise;
  } catch (err) {
    logger.warn("Something went wrong while determining enterprise url:", err);

    return;
  }
}
